import React from 'react';
import { BarDatum, BarTooltipComponent } from '@nivo/bar';

import StackedBar from '~components/visualisation/bar/StackedBar';

export interface StackedBudgetBarProps {
  budget: number;
  utilization: number;
  color?: string;
  budgetKey?: string;
  utilizationKey?: string;
  overKey?: string;
  legendTitle?: string;
  axisLeftLegend?: string;
  valueFormatter?: (value: number) => string;
  tooltip?: BarTooltipComponent<any>;
}

const StackedBudgetBar: React.FC<StackedBudgetBarProps> = ({
  budget,
  utilization,
  color,
  budgetKey = 'Remaining',
  utilizationKey = 'Utilization',
  overKey = 'Over',
  legendTitle = 'Budget vs Utilization',
  axisLeftLegend = '',
  valueFormatter = (v) => v.toString(),
  tooltip,
}) => {
  const over = utilization > budget ? utilization - budget : 0;
  const used = Math.min(utilization, budget);
  const remainder = budget - used;
  const barData = [
    {
      metric: '',
      [utilizationKey]: used,
      [overKey]: over,
      [budgetKey]: remainder,
    },
  ];
  const keys = [utilizationKey, budgetKey, overKey];
  const colors = ({ id }: BarDatum) => {
    if (id === budgetKey) return color || '#4caf50';
    if (id === utilizationKey) return 'orange';
    if (id === overKey) return '#e53935';
    return '#ccc';
  };
  const defaultTooltip: BarTooltipComponent<any> = ({ id, value, color: tooltipColor }) => (
    <div className="budget-bar-tooltip">
      <div className="budget-bar-budget">
        <span className="budget-bar-budget-dot" style={{ backgroundColor: tooltipColor }} />
        <span className="budget-bar-budget-label">{id}:</span>
        <strong>{valueFormatter(value)}</strong>
      </div>
    </div>
  );

  return (
    <StackedBar
      data={barData}
      keys={keys}
      colors={colors}
      legendTitle={legendTitle}
      axisLeftLegend={axisLeftLegend}
      valueFormatter={valueFormatter}
      minValue={0}
      maxValue={Math.max(budget, utilization)}
      tooltip={tooltip || defaultTooltip}
    />
  );
};

export default StackedBudgetBar;
